var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from "styled-components";
export var mainStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    font-family: " + theme.font.default + ";\n    color: " + theme.colors.utility.ink + ";\n  ";
});
export var boldStyles = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: 12px;\n  text-transform: uppercase;\n  line-height: 14px;\n  letter-spacing: 0.2px;\n\n  ", "\n"], ["\n  font-family: ", ";\n  font-size: 12px;\n  text-transform: uppercase;\n  line-height: 14px;\n  letter-spacing: 0.2px;\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.font.bold;
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.tablet(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 12px;\n    line-height: 14px;\n    letter-spacing: 0.25px;\n  "], ["\n    font-size: 12px;\n    line-height: 14px;\n    letter-spacing: 0.25px;\n  "])));
});
export var regularStyles = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: 0.1px;\n\n  ", "\n"], ["\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: 0.1px;\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.tablet(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 14px;\n    line-height: 16px;\n    letter-spacing: 0.1px;\n  "], ["\n    font-size: 14px;\n    line-height: 16px;\n    letter-spacing: 0.1px;\n  "])));
});
export var labelWhite = css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.utility.white;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
